import React from 'react';
import {
  IconStethoscope,
  IconToolsKitchen2,
  IconScissors,
  IconCar,
  IconHome,
  IconShoppingCart,
  IconSchool,
  IconDots,
} from '@tabler/icons-react';

const BUSINESS_TYPES = [
  { key: 'clinic', label: 'Clínica', icon: IconStethoscope, color: '#10b981' },
  { key: 'restaurant', label: 'Restaurante', icon: IconToolsKitchen2, color: '#f59e0b' },
  { key: 'beauty', label: 'Salão de Beleza', icon: IconScissors, color: '#ec4899' },
  { key: 'automotive', label: 'Automotivo', icon: IconCar, color: '#3b82f6' },
  { key: 'realestate', label: 'Imobiliária', icon: IconHome, color: '#0ea5e9' },
  { key: 'ecommerce', label: 'E-commerce', icon: IconShoppingCart, color: '#2563eb' },
  { key: 'education', label: 'Educação', icon: IconSchool, color: '#14b8a6' },
  { key: 'other', label: 'Outro', icon: IconDots, color: '#64748b' },
];

const BusinessTypeSelector = ({ value, onChange }) => {
  return (
    <div className="awc-types__grid" role="radiogroup" aria-label="Tipo de negócio">
      {BUSINESS_TYPES.map((type) => {
        const Icon = type.icon;
        const isSelected = value === type.key;
        return (
          <div
            key={type.key}
            className={`awc-types__card${isSelected ? ' awc-types__card--selected' : ''}`}
            onClick={() => onChange(type.key)}
            role="radio"
            aria-checked={isSelected}
            tabIndex={0}
            aria-label={type.label}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onChange(type.key); } }}
          >
            <div className="awc-types__icon">
              <Icon size={32} color={type.color} stroke={1.5} />
            </div>
            <div className="awc-types__label">{type.label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default BusinessTypeSelector;
